import React, { FunctionComponent } from "react";
import { StarRating } from "coral-ui/components/v3";
import styles from "./RatingDisplay.css";

interface Props {
  rating: number;
  ratingScale?: number | null;
}

const RatingDisplay: FunctionComponent<Props> = ({ rating, ratingScale }) => {
  if (ratingScale === 5) {
    return <StarRating rating={rating} />;
  }

  return (
    <p className={styles.ratingText}>
      Rating: {rating}
      {ratingScale ? `/${ratingScale}` : ""}
    </p>
  );
};

export default RatingDisplay;
